import { Component, OnInit } from '@angular/core';
import { environment } from '@nrwl/environment';
import { AuthService } from '@nrwl/rx-service-auth';

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(authService: AuthService) {}

  ngOnInit() {}
}
